import React, { useContext, Fragment, useState } from "react";
import PropTypes from "prop-types";
import SettingsStartingDashboardPage from "./SettingsStartingDashboardPage";
import SettingsEditPassword from "./SettingsEditPassword";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { CredsContext } from "./Contexts";
import SettingsFavoriteProjects from "./SettingsFavoriteProjects";
import CustomAlert from "./CustomAlert";
import "./styles/Settings.css";

function SettingsUserPreferences(props) {
  const creds = useContext(CredsContext).creds;
  const [wait, setWait] = useState(false);
  const [openTourResetAlert, setOpenTourResetAlert] = useState(false);
  let profilePic = "noImage.png";
  const oadaSettingsString = localStorage.getItem("oadaSettings");
  if (oadaSettingsString) {
    const oadaSettings = JSON.parse(oadaSettingsString);
    if (oadaSettings.profilePic) {
      profilePic = "data:image/jpg;base64," + oadaSettings.profilePic;
    }
  }

  const handleTourReset = () => {
    localStorage.removeItem("toursVisited");
    setOpenTourResetAlert(true);
  };

  return (
    <Box>
      <CustomAlert
        alertText="Guided Tour Reset"
        openAlert={openTourResetAlert}
        setOpenAlert={setOpenTourResetAlert}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait}
        //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <FormControl>
        <FormLabel>
          <div className="settingsGroupTitle">User Preferences</div>
        </FormLabel>
        <br></br>
        <Box className="settingsBox">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="settingsUserProfileCell">
                  <img id="profilePic" src={profilePic} width="100px"></img>
                </TableCell>
                <TableCell className="settingsUserProfileCell">
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          width="200px"
                          className="settingsUserProfileCell"
                        >
                          {creds.name}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          width="200px"
                          className="settingsUserProfileCell"
                        >
                          {creds.username}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          width="200px"
                          className="settingsUserProfileCell"
                        >
                          {creds.role}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          with="200px"
                          className="settingsUserProfileCell"
                        >
                          <Button
                            sx={{ backgroundColor: "gray", color: "white" }}
                            onClick={handleTourReset}
                          >
                            Reset Guided Tour
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </FormControl>
      <br></br>
      {creds.userType == "generic" ? <SettingsEditPassword /> : null}
      <br></br>
      <SettingsStartingDashboardPage
        handleSettingsChange={props.handleSettingsChange}
      />
      <br></br>

      <br></br>
      {creds.userType == "generic" ? (
        <></>
      ) : (
        <SettingsFavoriteProjects waitHandler={setWait} />
      )}
      <br></br>
    </Box>
  );
}

export default SettingsUserPreferences;

SettingsUserPreferences.propTypes = {
  handleSettingsChange: PropTypes.func,
  setTarget: PropTypes.func,
};
